import { MainWithSkipLink } from '@amzn/stencil-react-components/a11y';
import { StencilProvider } from '@amzn/stencil-react-components/context';
import { PageContainer } from '@amzn/stencil-react-components/page';
import React from 'react';
import { Router } from 'react-router-dom';
import AppRoutes, { browserHistory } from 'src/AppRoutes';
import Authentication from 'src/components/Authentication';
import NavigationBar from 'src/components/NavigationBar';
const App = () => {
  return (
    <StencilProvider>
      <Authentication>
        <Router history={browserHistory}>
          <NavigationBar />
          <MainWithSkipLink>
            <PageContainer isFullWidth={true}>
              <AppRoutes />
            </PageContainer>
          </MainWithSkipLink>
        </Router>
      </Authentication>
    </StencilProvider>
  );
};
export default App;
